(ns app.domain.workspace-notification.model
  (:require [app.domain.licence.model :as licence-model]))

(def dormancy-notification-types
  [:workspace-notification.type/permit-month-to-expiration
   :workspace-notification.type/permit-expired
   :workspace-notification.type/permit-issued-six-months-ago])

(def pre-consultation-expiration-notification-types
  [:workspace-notification.type/pre-con-expiration-first-warning
   :workspace-notification.type/pre-con-expiration-second-warning
   :workspace-notification.type/pre-con-expiration-final-warning])

(def supported-levels
  "Which group-config levels are allowed for notification config?"
  ;; ATM, app.domain.workspace-notification.core/find-notification-values-for-group only works for these levels.
  ;; for L, they are the intended supported levels,
  ;; for CR, only permit-type level makes sense,
  ;; for pre-con, work-type/work-target don't make sense because those are selected during application phase
  ;; for future use cases, they might plausibly be supported, but find-notification-values-for-group has to be fixd
  #{:group-config.level/permit-type
    :group-config.level/category})

(def comply-by-notification-types
  [:workspace-notification.type/inspection-comply-by-date-approaches])

(def condition-due-date-notification-types
  [:workspace-notification.type/condition-due-in-30-days
   :workspace-notification.type/condition-due-in-3-days
   :workspace-notification.type/condition-overdue])

(def workspace-notification-types
  (concat dormancy-notification-types
          licence-model/notification-types
          pre-consultation-expiration-notification-types
          comply-by-notification-types
          condition-due-date-notification-types))
